(function(){'use strict';
var endpoint='https://lzcpiphfoscznxfxzqqz.supabase.co/functions/v1/prelaunch-public-status';
var launchDefault='2026-11-01T06:00:00Z';
var countdownTimer=null;
var gate=document.getElementById('pf-prelaunch-gate');
var root=document.documentElement;
function isPublicHome(){
  var p=(window.location.pathname||'/').replace(/\/+$/,'')||'/';
  return p==='/' || p==='/index';
}
function allowedPath(){
  var p=window.location.pathname||'/';
  return p==='/pages/list-your-business'||p==='/pages/register-as-a-pro'||p==='/pages/business-login'||p==='/pages/business-dashboard'||p==='/pages/verify-business-email'||p==='/pages/profind-admin'||p.indexOf('/policies/')===0||p.indexOf('/pages/privacy')===0||p.indexOf('/pages/terms')===0;
}
function setTime(launchAt){
  var target=new Date(launchAt||launchDefault).getTime();
  if (!Number.isFinite(target)) target=new Date(launchDefault).getTime();
  if (countdownTimer !== null) window.clearInterval(countdownTimer);
  function tick(){
    var d=Math.max(0,target-Date.now());
    var values={days:Math.floor(d/86400000),hours:Math.floor((d%86400000)/3600000),minutes:Math.floor((d%3600000)/60000),seconds:Math.floor((d%60000)/1000)};
    Object.keys(values).forEach(function(k){
      document.querySelectorAll('[data-pf-'+k+']').forEach(function(el){el.textContent=String(values[k]).padStart(2,'0');});
    });
  }
  tick(); countdownTimer=window.setInterval(tick,1000);
}
function setProof(count){
  document.querySelectorAll('[data-pf-social-proof]').forEach(function(el){
    if(Number(count)>=100) el.textContent=Number(count).toLocaleString('en-ZA')+' businesses are already registered and getting launch-ready.';
    else el.textContent='Businesses across South Africa are getting launch-ready.';
  });
}
function revealSite(){if(root.classList.contains('pf-prelaunch-navigating'))return;root.classList.remove('pf-prelaunch-pending','pf-prelaunch-active');if(gate)gate.hidden=true;}
function showGate(){root.classList.remove('pf-prelaunch-pending');root.classList.add('pf-prelaunch-active');if(gate)gate.hidden=false;initAIMotion();}
var aiMotionStarted=false;
function initAIMotion(){
  if(aiMotionStarted||!gate)return;
  aiMotionStarted=true;

  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine=matchMedia('(pointer:fine)').matches;
  var compact=innerWidth<981;
  var motionFactor=reduce?.28:1;

  var canvas=gate.querySelector('[data-pf-ai-canvas]');
  var glow=gate.querySelector('[data-pf-cursor-glow]');
  var ctx=canvas&&canvas.getContext?canvas.getContext('2d'):null;
  var parallax={x:0,y:0};
  var touch={active:false,x:innerWidth/2,y:innerHeight*.45};
  var nodes=[],lastNetwork=0,dpr=1;

  var cards=Array.prototype.slice.call(gate.querySelectorAll('[data-pf-float-card]'));

  function profile(card,index){
    var cls=card.className||'';
    if(cls.indexOf('--ai')>=0)return{scale:.88,rot:-3,ampX:18,ampY:14,speed:.48,phase:.25,depth:1.15};
    if(cls.indexOf('--dashboard')>=0)return{scale:.76,rot:4,ampX:15,ampY:17,speed:.41,phase:1.7,depth:.94};
    if(cls.indexOf('--emergency')>=0)return{scale:.79,rot:3,ampX:17,ampY:13,speed:.45,phase:2.9,depth:1.04};
    if(cls.indexOf('--reserve')>=0)return{scale:.80,rot:-3,ampX:16,ampY:15,speed:.38,phase:4.2,depth:1.08};
    if(cls.indexOf('--demand')>=0)return{scale:.66,rot:-1,ampX:11,ampY:16,speed:.32,phase:5.35,depth:.70};
    if(cls.indexOf('phone-preview')>=0)return{scale:.78,rot:2,ampX:9,ampY:13,speed:.29,phase:3.55,depth:.58};
    return{scale:1,rot:0,ampX:12,ampY:12,speed:.4,phase:index,depth:1};
  }

  var states=cards.map(function(card,index){
    return{
      card:card,p:profile(card,index),
      x:0,y:0,z:0,rx:0,ry:0,rz:0,lift:0,
      tx:0,ty:0,tz:0,trx:0,try:0,trz:0,tlift:0,
      vx:0,vy:0,vz:0,vrx:0,vry:0,vrz:0,vlift:0
    };
  });

  function resize(){
    compact=innerWidth<981;
    fine=matchMedia('(pointer:fine)').matches;
    motionFactor=reduce?.28:1;
    if(!canvas||!ctx)return;
    dpr=Math.min(devicePixelRatio||1,compact?1.0:1.5);
    canvas.width=Math.round(innerWidth*dpr);
    canvas.height=Math.round(innerHeight*dpr);
    canvas.style.width=innerWidth+'px';
    canvas.style.height=innerHeight+'px';
    ctx.setTransform(dpr,0,0,dpr,0,0);
    var count=compact?10:38;
    nodes=Array.from({length:count},function(_,i){
      return{x:Math.random()*innerWidth,y:Math.random()*innerHeight,vx:(Math.random()-.5)*(compact?.055:.12),vy:(Math.random()-.5)*(compact?.055:.12),r:.65+Math.random(),p:i%4===0};
    });
  }

  function setGlassFocus(x,y,active){
    var nearest=null,nearestDist=Infinity;
    states.forEach(function(s){
      var r=s.card.getBoundingClientRect();
      var cx=r.left+r.width/2,cy=r.top+r.height/2;
      var dx=x-cx,dy=y-cy;
      var dist=Math.max(70,Math.hypot(dx,dy));
      var influence=active?Math.max(0,1-Math.min(dist,500)/500):0;

      s.tx=(dx/dist)*13*influence*s.p.depth;
      s.ty=(dy/dist)*10*influence*s.p.depth;
      s.tz=18*influence;
      s.try=(dx/Math.max(260,r.width))*3.8*influence;
      s.trx=(-dy/Math.max(280,r.height))*3.0*influence;
      s.trz=(dx/innerWidth)*.85*influence;
      s.tlift=.035*influence;

      var px=Math.max(0,Math.min(100,(x-r.left)/Math.max(1,r.width)*100));
      var py=Math.max(0,Math.min(100,(y-r.top)/Math.max(1,r.height)*100));
      s.card.style.setProperty('--pf-shine-x',px.toFixed(1)+'%');
      s.card.style.setProperty('--pf-shine-y',py.toFixed(1)+'%');
      s.card.style.setProperty('--pf-shine-opacity',(influence*.92).toFixed(3));

      if(dist<nearestDist){nearestDist=dist;nearest=s;}
    });
    states.forEach(function(s){s.card.removeAttribute('data-pf-active')});
    if(active&&nearest&&nearestDist<360)nearest.card.setAttribute('data-pf-active','1');
  }

  function releaseGlass(){
    states.forEach(function(s){
      s.tx=0;s.ty=0;s.tz=0;s.trx=0;s.try=0;s.trz=0;s.tlift=0;
      s.card.style.setProperty('--pf-shine-opacity','0');
      s.card.removeAttribute('data-pf-active');
    });
  }

  function beginTouch(x,y){
    touch.active=true;touch.x=x;touch.y=y;
    setGlassFocus(x,y,true);
    if(glow){glow.style.left=x+'px';glow.style.top=y+'px';glow.style.opacity='.72'}
  }
  function moveTouch(x,y){
    touch.x=x;touch.y=y;
    if(touch.active)setGlassFocus(x,y,true);
    if(glow){glow.style.left=x+'px';glow.style.top=y+'px';glow.style.opacity=touch.active?'.72':'.18'}
  }
  function endTouch(){
    touch.active=false;
    releaseGlass();
    if(!fine&&glow)glow.style.opacity='0';
  }

  gate.addEventListener('pointerdown',function(e){beginTouch(e.clientX,e.clientY)},{passive:true});
  gate.addEventListener('pointermove',function(e){
    if(fine){
      parallax.x=e.clientX/innerWidth-.5;
      parallax.y=e.clientY/innerHeight-.5;
      touch.active=true;
      setGlassFocus(e.clientX,e.clientY,true);
      if(glow){glow.style.left=e.clientX+'px';glow.style.top=e.clientY+'px';glow.style.opacity='.50'}
    }else if(touch.active){
      moveTouch(e.clientX,e.clientY);
    }
  },{passive:true});
  gate.addEventListener('pointerup',endTouch,{passive:true});
  gate.addEventListener('pointercancel',endTouch,{passive:true});

  // iOS/WebKit fallback: explicit touch events.
  gate.addEventListener('touchstart',function(e){
    var p=e.touches&&e.touches[0];if(p)beginTouch(p.clientX,p.clientY);
  },{passive:true,capture:true});
  gate.addEventListener('touchmove',function(e){
    var p=e.touches&&e.touches[0];if(p)moveTouch(p.clientX,p.clientY);
  },{passive:true,capture:true});
  gate.addEventListener('touchend',endTouch,{passive:true,capture:true});
  gate.addEventListener('touchcancel',endTouch,{passive:true,capture:true});

  addEventListener('pointerleave',function(){
    if(fine){releaseGlass();if(glow)glow.style.opacity='.08'}
  },{passive:true});
  addEventListener('resize',resize,{passive:true});

  function drawNetwork(ts){
    if(!ctx||!canvas)return;
    var fps=compact?8:20;
    if(ts-lastNetwork<1000/fps)return;
    lastNetwork=ts;
    ctx.clearRect(0,0,innerWidth,innerHeight);
    for(var i=0;i<nodes.length;i++){
      var n=nodes[i];
      n.x+=n.vx;n.y+=n.vy;
      if(n.x<0||n.x>innerWidth)n.vx*=-1;
      if(n.y<0||n.y>innerHeight)n.vy*=-1;
      ctx.beginPath();ctx.arc(n.x,n.y,n.p?1.3:n.r,0,Math.PI*2);
      ctx.fillStyle=n.p?'rgba(91,214,255,.58)':'rgba(57,147,255,.24)';ctx.fill();
      for(var j=i+1;j<nodes.length;j++){
        var m=nodes[j],d=Math.hypot(m.x-n.x,m.y-n.y),maxD=compact?96:116;
        if(d<maxD){
          ctx.beginPath();ctx.moveTo(n.x,n.y);ctx.lineTo(m.x,m.y);
          ctx.strokeStyle='rgba(73,174,255,'+((1-d/maxD)*(compact?.075:.13))+')';
          ctx.lineWidth=.5;ctx.stroke();
        }
      }
    }
  }

  function spring(pos,vel,target,stiffness,damping){
    vel+=(target-pos)*stiffness;
    vel*=damping;
    pos+=vel;
    return[pos,vel];
  }

  function frame(ts){
    var t=ts/1000;
    states.forEach(function(s){
      var p=s.p;
      var idleX=Math.sin(t*p.speed+p.phase)*p.ampX*motionFactor;
      var idleY=Math.cos(t*(p.speed*.78)+p.phase*1.19)*p.ampY*motionFactor;
      var idleR=Math.sin(t*(p.speed*.43)+p.phase)*.62*motionFactor;

      var a=spring(s.x,s.vx,s.tx,.050,.86);s.x=a[0];s.vx=a[1];
      a=spring(s.y,s.vy,s.ty,.050,.86);s.y=a[0];s.vy=a[1];
      a=spring(s.z,s.vz,s.tz,.045,.84);s.z=a[0];s.vz=a[1];
      a=spring(s.rx,s.vrx,s.trx,.042,.83);s.rx=a[0];s.vrx=a[1];
      a=spring(s.ry,s.vry,s.try,.042,.83);s.ry=a[0];s.vry=a[1];
      a=spring(s.rz,s.vrz,s.trz,.042,.83);s.rz=a[0];s.vrz=a[1];
      a=spring(s.lift,s.vlift,s.tlift,.050,.84);s.lift=a[0];s.vlift=a[1];

      var px=fine?parallax.x*9*p.depth:0;
      var py=fine?parallax.y*7*p.depth:0;
      var scale=p.scale*(1+s.lift);

      var transform=
        'translate3d('+(idleX+s.x+px).toFixed(2)+'px,'+(idleY+s.y+py).toFixed(2)+'px,'+s.z.toFixed(2)+'px) '+
        'rotateX('+s.rx.toFixed(2)+'deg) '+
        'rotateY('+s.ry.toFixed(2)+'deg) '+
        'rotateZ('+(p.rot+idleR+s.rz).toFixed(2)+'deg) '+
        'scale('+scale.toFixed(4)+')';

      // Safari-safe: explicitly override any stale !important transform rule.
      s.card.style.setProperty('transform',transform,'important');
    });

    if(root.classList.contains('pf-prelaunch-active'))drawNetwork(ts);
    requestAnimationFrame(frame);
  }

  resize();
  requestAnimationFrame(frame);
}

if(gate){
  gate.querySelectorAll('a[href*="/pages/list-your-business"],a[href*="/pages/register-as-a-pro"]').forEach(function(link){
    link.addEventListener('click',function(){
      root.classList.add('pf-prelaunch-navigating','pf-prelaunch-active');
      if(gate)gate.hidden=false;
      var label=link.querySelector('span')?null:link;
      if(label)label.setAttribute('aria-busy','true');
    });
  });
}
setTime(launchDefault);
/* On the public homepage the PRE_LAUNCH gate always wins, regardless of device,
   stored auth session or mobile viewport. Only explicitly allowed business/setup
   routes bypass the gate. */
if(isPublicHome()){showGate();} else if(allowedPath()){revealSite();}
var controller=window.AbortController?new AbortController():null;
var timeout=window.setTimeout(function(){if(controller)controller.abort();},3500);
fetch(endpoint,{method:'GET',mode:'cors',cache:'no-store',signal:controller?controller.signal:undefined}).then(function(r){return r.json();}).then(function(data){
  window.clearTimeout(timeout);
  setTime(data.launch_at||launchDefault);setProof(data.registered_businesses);
  if(String(data.platform_state||'PRE_LAUNCH').toUpperCase()==='LIVE') revealSite();
  else if(isPublicHome()) showGate();
  else if(allowedPath()) revealSite();
  else showGate();
}).catch(function(){
  window.clearTimeout(timeout);
  if(isPublicHome()) showGate();
  else if(allowedPath()) revealSite();
  else showGate();
});
})();